import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { Project } from "../../lib/types"
import { realProject } from "../../constants"
import { v4 as uuidv4 } from "uuid"

export interface ProjectsState {
  items: Project[]
  status: "idle" | "loading" | "failed"
}

const initialState: ProjectsState = {
  items: realProject as Project[],
  status: "idle",
}

export const projectsSlice = createSlice({
  name: "projects",
  initialState,
  reducers: {
    addProject: (state, action: PayloadAction<Project>) => {
      state.items.push(action.payload)
    },
    updateProject: (state, action: PayloadAction<Project>) => {
      const index = state.items.findIndex((p) => p.id === action.payload.id)
      if (index !== -1) {
        state.items[index] = action.payload
      }
    },
    deleteProject: (state, action: PayloadAction<string>) => {
      state.items = state.items.filter((p) => p.id !== action.payload)
    },
    setProjects: (state, action: PayloadAction<Project[]>) => {
      state.items = action.payload
    },
  },
})

export const { addProject, updateProject, deleteProject, setProjects } = projectsSlice.actions
export default projectsSlice.reducer
